import { IService } from './IService';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AppSettings } from './app-settings';

@Injectable()
export class MenuService implements IService {

  public pages = [
    { "title": "MENU_PAGES.DASHBOARD.TITLE", "theme": "DashboardPage", "icon": "browsers", "listView": true, "component": "", "singlePage": true, mod: "URD", type: "READ" },
    { "title": "MENU_PAGES.PROFILE.TITLE", "theme": "ProfilePage", "icon": "contact", "listView": true, "component": "", "singlePage": true, mod: "URD", type: "READ" },
    { "title": "MENU_PAGES.REFREL.TITLE","des": "MENU_PAGES.REFREL.DESC", "theme": "ReferralPage", "icon": "trophy", "listView": true, "component": "", "singlePage": true, mod: "REFR", type: "CREATE" },
    { "title": "MENU_PAGES.COMPLEX.TITLE", "des": "MENU_PAGES.COMPLEX.DESC", "theme": "MySocietyPage", "icon": "body", "listView": true, "component": "", "singlePage": true, mod: "NTC", type: "READ" },
    { "title": "MENU_PAGES.ACCOUNTS.TITLE", "des": "MENU_PAGES.ACCOUNTS.DESC", "theme": "BillingPaymentsPage", "icon": "card", "listView": true, "component": "", "singlePage": true, mod: "BILL", type: "READ" },
    { "title": "MENU_PAGES.ENERGY_CONSUMPTION.TITLE", "des": "MENU_PAGES.ENERGY_CONSUMPTION.DESC", "theme": "MeterPage", "icon": "speedometer", "listView": true, "component": "", "singlePage": true, mod: "MTR", type: "READ" },
    { "title": "MENU_PAGES.SERVICE_REQUEST.TITLE", "des": "MENU_PAGES.SERVICE_REQUEST.DESC", "theme": "ComplaintTabsPage", "icon": "alert", "listView": true, "component": "", "singlePage": true, mod: "COM", type: "READ" },
    { "title": "MENU_PAGES.VISITS.TITLE", "des": "MENU_PAGES.VISITS.DESC", "theme": "VisitorTabsPage", "icon": "log-in", "listView": true, "component": "", "singlePage": true, mod: "VMS", type: "READ" },
    { "title": "MENU_PAGES.STAFFS.TITLE", "des": "MENU_PAGES.STAFFS.DESC", "theme": "MyStaffTabsPage", "icon": "people", "listView": true, "component": "", "singlePage": true, mod: "VMSSTF", type: "READ" },
    { "title": "MENU_PAGES.NOTICES.TITLE", "des": "MENU_PAGES.NOTICES.DESC", "theme": "NoticesPage", "icon": "clipboard", "listView": true, "component": "", "singlePage": true, mod: "NTC", type: "READ" },
    { "title": "MENU_PAGES.EVENTS.TITLE", "des": "MENU_PAGES.EVENTS.DESC", "theme": "EventsPage", "icon": "calendar", "listView": true, "component": "", "singlePage": true, mod: "EVNT", type: "READ" },

    //{"des":"", "title" : "Facility", "theme"  : "DashboardPage",  "icon" : "ribbon", "listView" : true, "component": "", "singlePage":true, mod : "ACC", type: "READ"},
    { "title": "MENU_PAGES.AMENITIES.TITLE", "des": "MENU_PAGES.AMENITIES.DESC", "theme": "FacilityPage", "icon": "home", "listView": true, "component": "", "singlePage": true, mod: "FBK", type: "READ" },
    { "title": "MENU_PAGES.SURVEY.TITLE", "des": "MENU_PAGES.SURVEY.DESC", "theme": "SurveyPage", "icon": "document", "listView": true, "component": "", "singlePage": true, mod: "SURVEY", type: "READ" },
    { "title": "MENU_PAGES.FAMILY_MEMBERS.TITLE", "theme": "MembersPage", "icon": "people", "listView": true, "component": "", "singlePage": true, mod: "FMB", type: "READ" },
    { "title": "MENU_PAGES.SETTINGS.TITLE", "theme": "SettingsPage", "icon": "settings", "listView": true, "component": "", "singlePage": true, mod: "URD", type: "READ" },
    { "title": "MENU_PAGES.HOW_IT_WORKS.TITLE", "theme": "HowItWorksPage", "icon": "md-help", "listView": true, "component": "", "singlePage": true, mod: "URD", type: "READ" },
    { "title": "MENU_PAGES.TELL_A_FRIEND.TITLE", "theme": "TellAFriend", "icon": "md-share", "listView": true, "component": "", "singlePage": true, mod: "URD", type: "READ" },
    { "title": "MENU_PAGES.CONTACT_US.TITLE", "theme": "FeedbackPage", "icon": "ios-mail", "listView": true, "component": "", "singlePage": true, mod: "URD", type: "READ" },
    // {"title" : "About us", "theme"  : "AboutUsPage",  "icon" : "ios-information-circle", "listView" : true, "component": "", "singlePage":true, mod : "URD", type: "READ"},
  ];

  constructor() {}

    getId = ():string => 'menu';

    getTitle = ():string => 'UIAppTemplate';

    getAllThemes = (): Array<any> => {
      return this.pages;
    };

    getDataForTheme = () => {
      return {
        "background": "assets/images/background/16.jpg",
        "image": "assets/images/logo/logo.png",
        "title": ""
      };
    };

    getEventsForTheme = (menuItem: any): any => {
      return {};
    };

    prepareParams = (item: any) => {
      return {
        title: item.title,
        data: {},
        events: this.getEventsForTheme(item)
      };
    };
}




// WEBPACK FOOTER //
// ./src/services/menu-service.ts